import { Helper } from './../../shared/helper';
import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChildren} from '@angular/core';
import {IAircraft} from '../aircraft';
import {ActivatedRoute, Router} from '@angular/router';
import {AircraftService} from '../aircraft.service';
import {FormBuilder, FormControlName, FormGroup, Validators} from '@angular/forms';
import {GenericValidator} from '../../shared/generic-validator';
import {Subscription} from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/observable/merge';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  templateUrl: './aircraft.component.html',
  styleUrls: ['./aircraft.component.css']
})
export class AircraftComponent implements OnInit, AfterViewInit {
  @ViewChildren(FormControlName, { read: ElementRef })
  formInputElements: ElementRef[];

  pageTitle: string;
  errorMessage: string;
  aircraftForm: FormGroup;
  aircraft: IAircraft;
  private _sub: Subscription;
  displayMessages: { [key: string]: string } = {};
  private _validationMessages: { [key: string]: { [key: string]: string } };
  private _genericValidator: GenericValidator;

  constructor(
    private _fb: FormBuilder,
    private _route: ActivatedRoute,
    private _router: Router,
    private _aircraftService: AircraftService,
    public activeModal: NgbActiveModal,
    private helper: Helper
  ) {
    this._validationMessages = {
      name: { required: 'Aircraft name is required.' },
      seats: {
        required: 'Seats quantity is required.',
        min: 'Seats quantity must be greater than 1.'
      }
    };
    this._genericValidator = new GenericValidator(this._validationMessages);
  }

  ngOnInit(): void {
    this.aircraftForm = this._fb.group({
      name: ['', Validators.required],
      seats: ['', [Validators.required, Validators.min(1)]]
    });

    if (this.aircraftForm) {
      this.aircraftForm.reset();
    }
    if (this.aircraft.id === 0) {
      this.pageTitle = 'Add Aircraft';
    } else {
      this.pageTitle = `Edit Aircraft: ${this.aircraft.name}`;
    }

    this.aircraftForm.patchValue({
      name: this.aircraft.name,
      seats: this.aircraft.seats
    });
  }

  ngAfterViewInit(): void {
    const controlBlurs: Observable<any>[] = this.formInputElements.map(
      (formControl: ElementRef) =>
        Observable.fromEvent(formControl.nativeElement, 'blur')
    );

    Observable.merge(this.aircraftForm.valueChanges, ...controlBlurs)
      .debounceTime(200)
      .subscribe(value => {
        this.displayMessages = this._genericValidator.processMessages(
          this.aircraftForm
        );
      });
  }

  saveAircraft(): void {
    if (this.aircraftForm.dirty && this.aircraftForm.valid) {
      const l = Object.assign({}, this.aircraft, this.aircraftForm.value);

      this._aircraftService.saveAircraft(l).subscribe(res => {
        this.aircraftForm.reset();
        this.activeModal.close(res);
      }, (error: any) => (this.errorMessage = <any>error));
    }
  }

  closeActiveModal() {
    if (this.aircraftForm.dirty) {
      if (confirm(`Are you sure to close form?`)) {
        this.activeModal.dismiss();
      }
    } else {
      this.activeModal.dismiss();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/aircrafts/single/aircraft.component.ts